import styled, { keyframes, css } from 'styled-components';
import { StatsSpinnerSize } from './types';

interface SpinnerItemStyledProps {
  animationDelay?: string;
  color?: string;
  size?: StatsSpinnerSize;
}

export const getSpinnerColor = ({ color }: SpinnerItemStyledProps) => {
  if (color) {
    return css`
      background-color: ${({ theme }) => theme.colors[color]};
    `;
  }
  return css`
    background-color: ${({ theme }) => theme.colors.blue[800]};
  `;
};

function getSize(props: SpinnerItemStyledProps) {
  switch (props.size) {
    case StatsSpinnerSize.LARGE:
      return css`
        ${({ theme }) => css`
          width: ${theme.spacings[450]};
          height: ${theme.spacings[450]};
        `}
      `;
    case StatsSpinnerSize.MEDIUM:
      return css`
        ${({ theme }) => css`
          width: ${theme.spacings[400]};
          height: ${theme.spacings[400]};
        `}
      `;
    case StatsSpinnerSize.SMALL:
    default:
      return css`
        ${({ theme }) => css`
          width: ${theme.spacings[300]};
          height: ${theme.spacings[300]};
        `}
      `;
  }
}

const pulse = keyframes`
     0%, 80%, 100% { transform: scale(0); }
     40% { transform: scale(1.0); }
`;

export const SpinnerContainerStyled = styled.div<SpinnerItemStyledProps>`
  text-align: center;
  > * {
    ${getSpinnerColor};
    ${getSize};
  }
`;

export const SpinnerItemStyled = styled.div<SpinnerItemStyledProps>`
  ${({ theme }) => css`
    margin-right: ${theme.spacings[200]};
  `}
  border-radius: 100%;
  display: inline-block;
  opacity: 0.4;
  animation: ${pulse} 1.4s infinite ease-in-out both;
  animation-delay: ${(props) => props.animationDelay};
`;
